/**
 * Page: Error
 * Gère l'affichage des erreurs avec paramètres URL
 */

import { KratosFlows } from '@/scripts/api/ory-client.js';

// Auto-initialisation au chargement de la page
document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const errorId = urlParams.get('id');
  const errorTitle = urlParams.get('title');
  const errorMessage = urlParams.get('message');
  const errorCode = urlParams.get('code');

  // Si on a un error ID, récupérer les détails depuis Kratos
  if (errorId) {
    try {
      const errorData = await KratosFlows.getFlowError(errorId);

      // Afficher le message d'erreur principal
      const messageEl = document.querySelector('[data-error-message]');
      if (messageEl && errorData.error) {
        // Utiliser le message court ou la raison
        const errorMsg = errorData.error.message || errorData.error.reason || 'Une erreur est survenue';
        messageEl.textContent = errorMsg;
      }

      // Afficher les détails techniques
      const codeEl = document.querySelector('[data-error-code]');
      const detailsEl = document.querySelector('[data-error-details]');
      if (codeEl && errorData.error) {
        // Formater les détails de manière lisible
        let errorDetails = `Code: ${errorData.error.code || 'N/A'} - ${errorData.error.status || 'N/A'}\n`;
        errorDetails += `ID: ${errorId}\n\n`;

        if (errorData.error.reason) {
          errorDetails += `Raison:\n${errorData.error.reason}\n\n`;
        }

        if (errorData.error.debug) {
          errorDetails += `Debug (stack trace):\n${errorData.error.debug}`;
        }

        codeEl.textContent = errorDetails;
        if (detailsEl) detailsEl.style.display = 'none'; // Masqué par défaut
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des détails:', error);
      const messageEl = document.querySelector('[data-error-message]');
      if (messageEl) {
        messageEl.textContent = 'Une erreur est survenue. Veuillez réessayer.';
      }
    }
  }

  // Fallback: Mettre à jour le contenu si présent dans l'URL (ancien système)
  if (errorTitle) {
    const titleEl = document.querySelector('[data-error-title]');
    if (titleEl) titleEl.textContent = errorTitle;
  }

  if (errorMessage) {
    const messageEl = document.querySelector('[data-error-message]');
    if (messageEl) messageEl.textContent = errorMessage;
  }

  if (errorCode && !errorId) {
    const codeEl = document.querySelector('[data-error-code]');
    const detailsEl = document.querySelector('[data-error-details]');
    if (codeEl) codeEl.textContent = `Code d'erreur: ${errorCode}`;
    if (detailsEl) detailsEl.style.display = 'block';
  }

  // Toggle des détails
  const toggleBtn = document.querySelector('[data-toggle-details]');
  const detailsEl = document.querySelector('[data-error-details]');

  if (toggleBtn && detailsEl) {
    toggleBtn.addEventListener('click', () => {
      const isHidden = detailsEl.style.display === 'none';
      detailsEl.style.display = isHidden ? 'block' : 'none';
      toggleBtn.textContent = isHidden ? 'Masquer les détails techniques' : 'Afficher les détails techniques';
    });
  }
});
